module.exports = __webpack_public_path__ + "img/LPTemp7.4791d7b9.png";